import csCZ from 'antd/locale/cs_CZ';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import frFR from 'antd/locale/fr_FR';
import nlBE from 'antd/locale/nl_BE';
import { Language } from '@data/utils/enums';

export const antdLocales = {
  [Language.EN]: enUS,
  [Language.NL]: nlBE,
  [Language.FR]: frFR,
  [Language.DE]: deDE,
  [Language.CS]: csCZ,
};
